import {
  Box,
  Button,
  IconButton,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { isDate } from 'date-fns'
import DeleteIcon from '@mui/icons-material/Delete'
import React from 'react'

export function ActionDatePicker(props) {
  const { readOnly, onChange, resetError, value, label, min, max } = props

  return (
    <Box pt={2} key={label}>
      <DatePicker
        inputFormat="dd/MM/yyyy"
        width={'100%'}
        disabled={readOnly}
        value={value || new Date()}
        label={label}
        minDate={min}
        maxDate={max}
        onChange={(value) => {
          resetError()
          // Explicitly check for a valid date
          if (isDate(value)) {
            if (value.getFullYear() > 1900) {
              onChange(value)
            } else {
              onChange()
            }
          } else {
            onChange()
          }
        }}
      />
    </Box>
  )
}

export function ActionInput(props) {
  const { readOnly, onChange, resetError, value, label, type } = props

  return (
    <Box pt={2} key={label}>
      <TextField
        data-testid={`input-text-${label}`}
        size="small"
        type={type}
        value={value}
        label={label}
        onChange={(e) => {
          resetError()
          onChange(e.target.value)
        }}
        onBlur={(e) => {
          onChange(e.target.value)
        }}
        disabled={readOnly}
      />
    </Box>
  )
}

export function ActionSwitch(props) {
  const { readOnly, onChange, resetError, value, labelLeft, label } = props

  return (
    <Box pt={2} key={label}>
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        {labelLeft && <Typography>{labelLeft}</Typography>}
        <Switch
          data-testid={`switch-${label}`}
          checked={value}
          onChange={(e) => {
            resetError()
            onChange(e.target.checked)
          }}
          disabled={readOnly}
        />
        {label && <Typography>{label}</Typography>}
      </Stack>
    </Box>
  )
}

export function ActionDocumentUpload(props) {
  const {
    readOnly,
    readFileAndSendData,
    resetError,
    onReset,
    value,
    label,
    loadLabel,
    accept,
  } = props
  return (
    <Box pt={2} key={label}>
      {value ? (
        <Stack
          flexDirection="row"
          justifyContent="space-between"
          alignContent={'center'}
          alignItems={'center'}
        >
          <div>{label}</div>
          <IconButton
            data-testid="options-action"
            aria-label="Delete"
            onClick={onReset}
          >
            <DeleteIcon />
          </IconButton>
        </Stack>
      ) : (
        <label htmlFor={`upload-${label}`}>
          <input
            accept={accept ?? '.pdf'}
            id={`upload-${label}`}
            type="file"
            disabled={readOnly}
            style={{ display: 'none' }}
            onChange={(e) => {
              resetError()
              if (e.target.files.length) {
                const file = e.target.files[0]

                readFileAndSendData(file)
                e.target.value = null
              }
            }}
          />
          <Button
            color={'primary'}
            variant="contained"
            component="span"
            disabled={readOnly}
          >
            {loadLabel}
          </Button>
        </label>
      )}
    </Box>
  )
}
